import { Container } from "react-bootstrap";
import RowOne from "./RowOne";
import "./FeaturedProjects.css";
import RowTwo from "./RowTwo";
export default function FeaturedProjects() {






  return (
    <section
      id="featured-projects"
      className="featured-projects"
    >
      <Container>
        <RowOne />
        <RowTwo />
      </Container>
    </section>
  );
}
